export function createList<T>(values: T[]) {
    const set = new Set(values)

    function toggle(value: T) {
        !set.delete(value) && set.add(value)
        return Array.from(set)
    }

    return { toggle }
}
